import { trackEvent } from "@/services/posthog.service";

export const EVENT_MUNICIPAL_PROPERTY_CREATED = "MUTATION:MUNICIPAL_PROPERTY:CREATED";
export const EVENT_MUNICIPAL_PROPERTY_REGISTER_CREATED = "MUTATION:MUNICIPAL_PROPERTY_REGISTER:CREATED";

type MunicipalPropertyEventType =
  | typeof EVENT_MUNICIPAL_PROPERTY_CREATED
  | typeof EVENT_MUNICIPAL_PROPERTY_REGISTER_CREATED;

export const trackMunicipalPropertyEvent = (event: MunicipalPropertyEventType, payload: Record<string, unknown>) => {
  trackEvent(event, payload);
};
